export const fieldMarkerSvgIcon = `
<svg
  width="20px"
  height="20px"
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.2297 4.80137C11.2297 7.08455 9.00349 8.93598 9.00349 8.93598C9.00349 8.93598 6.77808 7.08455 6.77808 4.80137C6.77808 2.51819 9.00349 0.666016 9.00349 0.666016C9.00349 0.666016 11.2297 2.51744 11.2297 4.80137Z"
    stroke="white"
    stroke-width="1.2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.0624 15.0584C12.7607 17.3638 8.9993 17.329 8.9993 17.329C8.9993 17.329 8.96449 13.564 11.2662 11.2623C13.5679 8.96058 17.3329 8.99613 17.3329 8.99613C17.3329 8.99613 17.3633 12.7627 15.0624 15.0584Z"
    stroke="white"
    stroke-width="1.2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.93293 15.0584C5.23463 17.3638 8.99969 17.329 8.99969 17.329C8.99969 17.329 9.0345 13.564 6.7328 11.2623C4.43111 8.96058 0.66678 8.99613 0.66678 8.99613C0.66678 8.99613 0.631232 12.7627 2.93293 15.0584Z"
    stroke="white"
    stroke-width="1.2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M9.00317 8.93555V17.3284"
    stroke="white"
    stroke-width="1.2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
`;

export const transportMarkerSvgIcon = `
<svg width="22" height="22" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4269_143692)">
<path d="M23.5 13C19.916 13 17 15.916 17 19.5C17 23.084 19.916 26 23.5 26C27.084 26 30 23.084 30 19.5C30 15.916 27.084 13 23.5 13ZM23.5 25C20.4675 25 18 22.5325 18 19.5C18 16.4675 20.4675 14 23.5 14C26.5325 14 29 16.4675 29 19.5C28.9999 22.5325 26.5324 25 23.5 25Z" fill="white"/>
<path d="M23.5 16.5C21.8455 16.5 20.5 17.8455 20.5 19.5C20.5 21.1545 21.8455 22.5 23.5 22.5C25.1545 22.5 26.5 21.1545 26.5 19.5C26.5 17.8455 25.1545 16.5 23.5 16.5ZM23.5 21.5C22.397 21.5 21.5 20.603 21.5 19.5C21.5 18.397 22.397 17.5 23.5 17.5C24.603 17.5 25.5 18.397 25.5 19.5C25.5 20.603 24.603 21.5 23.5 21.5Z" fill="white"/>
<path d="M5.49998 18.5C4.39695 18.5 3.5 19.397 3.5 20.5C3.5 21.603 4.39695 22.5 5.49998 22.5C6.60295 22.5 7.49996 21.603 7.49996 20.5C7.49996 19.397 6.60295 18.5 5.49998 18.5ZM5.49998 21.5C4.9485 21.5 4.49996 21.0515 4.49996 20.5C4.49996 19.9485 4.94844 19.5 5.49998 19.5C6.05146 19.5 6.5 19.9484 6.5 20.5C6.49994 21.0515 6.05146 21.5 5.49998 21.5Z" fill="white"/>
<path d="M27 9.49996H25.11L24.61 6.99994H25C25.276 6.99994 25.5 6.77647 25.5 6.49996V4.49998C25.5 4.22348 25.276 4 25 4H14.5C13.1215 4 12 5.12148 12 6.50002C12 6.77652 12.224 7 12.5 7H13.45L13.0209 11.504C13.0134 11.504 13.0075 11.5 13 11.5H7.5C5.59898 11.5 4.15652 13.4015 4.01402 15.2095C1.70197 15.86 0 17.9825 0 20.5C0 23.5325 2.4675 26 5.50002 26C8.191 26 10.4325 24.056 10.9045 21.5H15.6405C15.7896 21.5 15.9305 21.4335 16.0256 21.319C16.1205 21.2045 16.1596 21.0535 16.1316 20.9071C16.0441 20.446 16.0001 19.9725 16.0001 19.5C16.0001 15.3646 19.3646 12 23.5001 12C25.6506 12 27.7006 12.9255 29.1251 14.539C29.2621 14.6945 29.4826 14.748 29.6766 14.6755C29.8711 14.6025 29.9996 14.416 30.0001 14.208V12.5C30 10.8455 28.6545 9.49996 27 9.49996ZM5.50002 25C3.01904 25 1.00002 22.9815 1.00002 20.5C1.00002 18.0185 3.01904 16 5.50002 16C7.981 16 10 18.0185 10 20.5C10 22.9815 7.981 25 5.50002 25ZM15.0585 20.5H11C11 17.4675 8.53248 15 5.49996 15C5.34645 15 5.19498 15.0105 5.04445 15.023C5.10645 14.6695 5.23295 14.3125 5.41143 13.982C5.44143 13.9875 5.46844 14 5.4999 14H6.49992C6.7759 14 6.9999 13.7765 6.9999 13.5C6.9999 13.2235 6.7759 13.0001 6.49992 13.0001H6.21141C6.5874 12.6941 7.02738 12.5001 7.49988 12.5001H12.9264L12.5024 16.9526C12.4894 17.0925 12.5354 17.2321 12.6304 17.3366C12.7249 17.4406 12.8589 17.5001 12.9999 17.5001H15.2474C15.0915 18.1425 15 18.81 15 19.5C15 19.834 15.0195 20.1685 15.0585 20.5ZM23.5 11C19.866 11 16.7665 13.2965 15.553 16.5105C15.535 16.5085 15.519 16.5 15.5 16.5H13.55L14.455 7H23.59L24.4005 11.053C24.1025 11.0215 23.8025 11 23.5 11ZM24.5 5.99998H13.0855C13.292 5.41797 13.848 4.99996 14.5 4.99996H24.5V5.99998H24.5ZM29 13.0195C27.975 12.15 26.758 11.5449 25.457 11.2364L25.31 10.4999H27C28.103 10.4999 29 11.3969 29 12.4999V13.0195Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4269_143692">
<rect width="30" height="30" fill="white"/>
</clipPath>
</defs>
</svg>`;
